import _extends from "@babel/runtime/helpers/extends";
import { bool, shape, string } from "prop-types";
import React, { useEffect, useState } from "react";

//Hooks
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { useLocation } from "react-router-dom";
import { setTypeHeaderAction } from "@Redux/typeHeader/typeHeader.action";

//Components
import Icon from "@Components/Icon";
import LinkBetween from "@Components/LinkBetween/LinkBetween";
import Image from "../Image";

//Style
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./header.module.scss";

//Asset
import { useDispatch } from "react-redux";
import logo_default from "@Src_main/assets/images/miscusi_logo.svg";
import logo_default_mobile from "@Src_main/assets/images/miscusi_logo_mobile.svg";
import UIkit from "uikit";
import SecondaryActionsShow from "./secondaryActions";
import { useCheckoutContext } from "@magento/peregrine/lib/context/checkout";
import NavigationTrigger from "./navTrigger";
import { useHistory } from "@magento/venia-ui/lib/drivers";
var HeaderDesktop = React.lazy(() => import("./headerDesktop").then(module => ({
  default: module.HeaderDesktop
})));
var SubMenuDefault2 = React.lazy(() => import("./headerDesktop").then(module => ({
  default: module.SubMenuDefault2
})));
var SubMenuDefault3 = React.lazy(() => import("./headerDesktop").then(module => ({
  default: module.SubMenuDefault3
})));
var TopBarHeader = React.lazy(() => import("./headerDesktop").then(module => ({
  default: module.TopBarHeader
})));
var Header = props => {
  var {
    type
  } = props;
  var classes = mergeClasses(defaultClasses, props.classes);
  var history = useHistory();
  var {
    isMobile
  } = useWindowSize();
  var [{
    tableData
  }] = useCheckoutContext();
  var isDefault = type.indexOf("default") !== -1;
  var isWhite = type.indexOf("white") !== -1;
  var hideLoyaltyModal = type.indexOf("noloyalty") !== -1;
  var headerTypeColor = isWhite ? classes.versionWhite : classes.versionRed;
  var logoTypeDesktop = logo_default;
  var logoTypeMobile = logo_default_mobile;
  var location = useLocation();
  var goToRegistration = () => {
    try {
      UIkit.offcanvas("#offcanvas-login-dx").show();
    } catch (error) {
      console.error(error);
    }
  };
  var topBarHeaderDesktop = isMobile ? null : /*#__PURE__*/React.createElement(TopBarHeader, {
    type: type,
    extraClasses: classes
  });
  var subMenuDesktop = !isMobile && isDefault ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubMenuDefault2, {
    type: type,
    classes: classes
  }), /*#__PURE__*/React.createElement(SubMenuDefault3, {
    classes: classes
  })) : null;
  var orderMenuLink = tableData !== null && tableData !== void 0 && tableData.cps && tableData !== null && tableData !== void 0 && tableData.cpt ? "/?cps=" + tableData.cps + "&cpt=" + tableData.cpt : "";
  var isOrderMenuPage = location.pathname === "/" && !!orderMenuLink;
  var primaryActionsShow = /*#__PURE__*/React.createElement("div", {
    className: "uk-navbar-left primary-actions ".concat(classes.primaryActions)
  }, isMobile ? location.pathname.endsWith("/homepage") || isOrderMenuPage || !orderMenuLink ? /*#__PURE__*/React.createElement(NavigationTrigger, null) : /*#__PURE__*/React.createElement(LinkBetween, {
    toTakeAway: true,
    href: orderMenuLink,
    className: classes.backButton
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-arrow-left",
    color: "white",
    isCircled: true
  })) : /*#__PURE__*/React.createElement(HeaderDesktop, {
    type: type,
    classes: classes
  }));
  var isHomePage = location.pathname == "/";
  var logoImage = /*#__PURE__*/React.createElement(Image, {
    alt: "Miscusi Logo",
    height: isMobile ? 48 : 30,
    src: isMobile ? logoTypeMobile : logoTypeDesktop,
    title: "Miscusi",
    width: isMobile ? 48 : 140,
    displayPlaceholder: false
  });
  var logoImageFull = /*#__PURE__*/React.createElement(Image, {
    alt: "Miscusi Logo",
    height: 72,
    src: logoTypeDesktop,
    title: "Miscusi_Logo",
    width: 72,
    displayPlaceholder: false
  });
  var logoHeader = () => {
    return /*#__PURE__*/React.createElement("div", null, logoImage);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.enableServiceBar
  }, /*#__PURE__*/React.createElement("header", {
    className: "uk-position-top ".concat(classes.root, " ").concat(headerTypeColor, " ").concat(isOrderMenuPage ? classes.takeaway : "")
  }, topBarHeaderDesktop, /*#__PURE__*/React.createElement("div", {
    className: "main-container ".concat(classes.mainContainer),
    "data-uk-sticky": "animation: uk-animation-fade"
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-container-xxlarge"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "uk-navbar-container uk-navbar-transparent",
    "data-uk-navbar": ""
  }, primaryActionsShow, /*#__PURE__*/React.createElement("div", {
    className: "logo-container ".concat(classes.logoContainer, " uk-navbar-center ").concat(!isDefault ? "mini-logo " + classes.miniLogo : ""),
    onClick: () => {
      history.push("/homepage");
    }
  }, isHomePage ? /*#__PURE__*/React.createElement("h1", {
    className: "uk-margin-remove"
  }, logoHeader()) : logoHeader()), /*#__PURE__*/React.createElement(SecondaryActionsShow, {
    classes: classes,
    goToRegistration: goToRegistration,
    hideLoyaltyModal: true
  })))), subMenuDesktop));
};
var HeaderWrapper = props => {
  var [headerType, setHeaderType] = useState();
  var location = useLocation();
  HeaderWrapper.switch = setHeaderType;
  var dispatch = useDispatch();
  var hiddenLocation = ["/login-feedback", "/checkout-feedback", "/area-personale", "/signup"];
  //setTypeHeaderAction
  if (headerType) {
    dispatch(setTypeHeaderAction(headerType));
  }
  if (headerType === "hidden" || hiddenLocation.includes(location.pathname)) {
    return null;
  } else if (headerType) {
    return /*#__PURE__*/React.createElement(Header, _extends({}, props, {
      type: headerType
    }));
  } else {
    return /*#__PURE__*/React.createElement(Header, _extends({}, props, {
      type: "default-red"
    }));
  }
};
HeaderWrapper.switch = () => {};

/**
 *
 * @param {'hidden'|"default-white"|'default-red'} onMountType
 */
export function useHeaderType(onMountType) {
  useEffect(() => {
    HeaderWrapper.switch(onMountType);
  }, [onMountType]);
}
Header.propTypes = {
  type: string.isRequired
};
Header.defaultProps = {
  type: "default-red"
};
export default HeaderWrapper;